export const consultingAnalysis = {
    title: 'Client management',
    list: {
        detailTitle: 'Analysis Parameters',
        title: 'Consulting Analysis History',
        usage_or_client_folder: 'Project Name',
        theme_name: 'Theme Name',
        patent_count: 'Expected Patent Count',
        patent_period_start: 'Patent Application Period - Start',
        patent_period_end: 'Patent Application Period - End',
        investment_period_start: 'Investment Data Analysis Period - Start',
        investment_period_end: 'Investment Data Analysis Period - End',
        ipc_digit: 'IPC Digits After "/"',
        one_cluster_one_ipc: '1 Cluster 1 IPC Mode',
        is_cvc: 'Is CVC',
        created_date: 'Created Date',
        status: {
            title: 'Status',
            pending: 'Pending',
            analysis: 'Analyzing',
            success: 'Success',
            failed: 'Failed',
            undefined: 'NULL'
        },
        id: 'DL',
        databricks_url: 'Log URL',
        parameters_str: 'Parameters',
        user_name: 'Executed By',
        parameters_str_button: 'View',
        copyParameters: 'Copy Parameters',
        copySuccess: 'Copied successfully',
        copyFailed: 'Failed to copy',
        searchAll: 'Search all',
        userInputPlaceholder: 'Please enter a keyword'
    },
    upload: {
        title: 'Upload',
        pageTitle: 'RAW_DATA Upload',
        parametersLabel: 'Parameters',
        parametersPlaceholder: 'Paste a single row from the consulting management sheet',
        selectZipLabel: 'RAW_DATA ZIP File Selection',
        confirmTitle: 'Review Your Details',
        back: 'Back',
        submit: 'Submit',
        processingButton: 'Processing...',
        processing: 'Processing...Please Wait',
        uploadComplete: 'Upload Completed',
        leavePageWarning: 'Processing in progress. Are you sure you want to leave this page?',
        error: {
            selectZip: 'Please select a ZIP file',
            enterParameters: 'Please enter the parameters',
            emptyClientFolder: 'Project Name is empty',
            emptyThemeName: 'Theme Name is empty',
            invalidPatentCount: 'Expected Patent Count must be a number',
            invalidPatentPeriodStart: 'Patent Application Period - Start format is invalid',
            invalidPatentPeriodEnd: 'Patent Application Period - End format is invalid',
            invalidInvestmentPeriodStart: 'Investment Data Analysis Period - Start format is invalid',
            invalidInvestmentPeriodEnd: 'Investment Data Analysis Period - End format is invalid',
            invalidIpcDigit: 'IPC Digits After "/" is invalid',
            invalidOneClusterOneIpc: '1 Cluster 1 IPC Mode is invalid',
            invalidIsCvc: 'Value Chain Analysis Mode is invalid',
            networkError:
                'A communication error has occurred. This may happen due to an unstable network connection. Please check your network connection and try again. If the issue persists, please contact the development team.'
        },
        chooseFile: 'Choose File',
        noFileSelected: 'No file selected',
        fileSelectNote: '* Loading may take a moment'
    }
}
